import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { SectionCta } from '../SectionCta';
import { faqs } from '../../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-white px-4 py-16 sm:py-20" aria-labelledby="faq-title" data-id="element-98" data-mp="1223kzg8hxg4h">
      <div className="mx-auto max-w-3xl" data-id="element-99" data-mp="1pshd16r2zez2">
        <h2 id="faq-title" className="text-center font-serif text-[32px] font-black leading-tight text-ink sm:text-5xl" data-id="element-100" data-mp="1ptinb909vxfq">
          Frequently asked questions
        </h2>
        <div className="mt-10 space-y-3" data-id="element-101" data-mp="1g2xq9q08z0yx">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} className={`rounded-2xl border-2 transition-colors duration-150 ${isOpen ? 'border-gold bg-cream' : 'border-ink/10 bg-white'}`} data-id="element-102" data-mp="1kzwi21wfuvty" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 p-5 text-left" data-id="element-103" data-mp="2dibkt9wjmdcg">
                  <span className="text-[17px] font-bold text-ink" data-id="element-104" data-mp="2jpb65zm6gz4x">{f.q}</span>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-ink transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-105" data-mp="2yhd1d6daz3ym" />
                </button>
                <AnimatePresence initial={false} data-id="element-106" data-mp="32ieztkzebbzj">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-107" data-mp="3hemhoenc01bn">
                      <p className="px-5 pb-5 text-[16px] leading-relaxed text-ink/80" data-id="element-108" data-mp="1i3mrfizi5lh2">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
        <SectionCta label="I’m ready — give me access" data-id="element-109" data-mp="2gqvq1kgt5h9c" />
      </div>
    </section>;
}